import { useMemo } from 'react';

import { useMy } from '@/hooks/useMy';
import { Setting } from '@/types';

/**
 * Hook to fetch customer display names for all tenants.
 * Uses the settings resource with name='display-name' to retrieve customer display names.
 */
export const useCustomerDisplayName = (props?: { enabled?: boolean }) => {
  const query = useMy(
    {
      resource: 'setting',
      allTenants: true,
    },
    {
      enabled: props?.enabled ?? true,
      doNotImpersonate: true, // Customer management should always run as the actual user
    }
  );

  const dataMap = useMemo(() => {
    // Filter for settings where name === 'display-name'
    const settings: Setting[] =
      query.data?.filter(item => item.name === 'display-name') || [];

    // Map by email (username field) to display name (value field)
    return new Map(
      settings.map(item => [
        item.username, // email address
        typeof item.value === 'string' ? item.value : item.username,
      ])
    );
  }, [query.data]);

  return {
    ...query,
    dataMap,
  };
};
